// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"b1d0992f","375":"0d6911d0","403":"80f3ac4d","508":"818e6daa","796":"9bde5186","800":"24ebc13e","815":"e0a9cbd3"}[chunkId] + ".chunk.js";
};